import { navigate } from 'gatsby';
import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { MANAGE_PROFILE } from '@constants/routes';

import { useIsMobile } from '@hooks/useIsMobile';

import ManageAccountLayout from '@views/ManageAccount/ManageAccountLayout';

const messages = defineMessages({
  title: {
    id: 'manageAccount.title',
    defaultMessage: 'User Profile',
  },
});

export default function ManageAccountPage(props: PagePropsWithBreadcrumbs) {
  const { formatMessage } = useIntl();

  const isMobile = useIsMobile();

  useEffect(() => {
    // Redirect to profile and security page if on desktop
    if (!isMobile) {
      navigate(MANAGE_PROFILE);
    }
  }, [isMobile]);

  return (
    <ManageAccountLayout
      friendlyName={formatMessage(messages.title)}
      pageProps={props}
    />
  );
}
